import { Confirmar } from './Confirmar.tsx';
import type { Pendencia } from '../lib/formulario.ts';

/**
 * As duas perguntas que todo formulário do Hub faz: "salvar?" e "descartar?".
 *
 * Fica num componente só para que a redação seja idêntica em toda tela. Aviso
 * escrito de um jeito em cada lugar é aviso que a pessoa para de ler.
 */
export function GuardaDoFormulario({
  pendencia,
  oQue,
  aoCancelar,
  aoSalvar,
  aoDescartar,
  aviso,
}: {
  pendencia: Pendencia;
  /** O que está sendo salvo. Ex.: "o cliente", "o caso 2026-001". */
  oQue: string;
  /** Uma frase a mais na pergunta de salvar — o que sai ao gravar, por exemplo (18/09/2026). */
  aviso?: string;
  aoCancelar: () => void;
  aoSalvar: () => void;
  aoDescartar: () => void;
}) {
  if (pendencia === 'salvar') {
    return (
      <Confirmar
        titulo="Salvar alterações"
        descricao={`Gravar as alterações em ${oQue}?${aviso ? ` ${aviso}` : ''}`}
        rotuloAcao="Sim, salvar"
        aoFechar={aoCancelar}
        aoConfirmar={aoSalvar}
      />
    );
  }

  if (pendencia === 'descartar') {
    return (
      <Confirmar
        titulo="Descartar alterações"
        descricao={`Você mexeu em ${oQue} e ainda não salvou. Fechar agora perde o que foi digitado.`}
        rotuloAcao="Descartar"
        aoFechar={aoCancelar}
        aoConfirmar={aoDescartar}
      />
    );
  }

  return null;
}
